import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';

export const initialState = {
  abTests: {},
  abSegments: [],
  isSegmentsLoaded: false,
  segmentsAbTests: []
};

export const useABTestStore = createHookStore(
  STORE_NAMES.AB_TEST,
  initialState
);
